function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 28C28 28.5304 27.7893 29.0391 27.4142 29.4142C27.0391 29.7893 26.5304 30 26 30H2C1.46957 30 0.960859 29.7893 0.585787 29.4142C0.210714 29.0391 0 28.5304 0 28V2C0 1.46957 0.210714 0.960859 0.585787 0.585787C0.960859 0.210714 1.46957 0 2 0H22C22.5216 5.23081e-05 23.0225 0.203873 23.396 0.568L27.396 4.412C27.5871 4.59831 27.7391 4.82099 27.8428 5.06693C27.9465 5.31287 28 5.57708 28 5.844V28Z",
  fill: "#1B75BB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6507 20.88C11.4767 20.9667 11.2834 21.0076 11.0891 20.9987C10.8949 20.9898 10.7062 20.9314 10.5408 20.8291C10.3755 20.7268 10.239 20.584 10.1443 20.4141C10.0497 20.2443 10 20.0531 10 19.8586V12.1413C10 11.9468 10.0497 11.7556 10.1443 11.5858C10.239 11.4159 10.3755 11.2731 10.5408 11.1708C10.7062 11.0685 10.8949 11.0101 11.0891 11.0012C11.2834 10.9923 11.4767 11.0332 11.6507 11.12L19.3693 14.98C19.5589 15.0746 19.7183 15.2201 19.8298 15.4003C19.9412 15.5805 20.0002 15.7881 20.0002 16C20.0002 16.2118 19.9412 16.4195 19.8298 16.5996C19.7183 16.7798 19.5589 16.9253 19.3693 17.02L11.6507 20.88Z",
  fill: "#CFE0EE"
});

function SvgTutorial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.c860df8f.svg";
export { ForwardRef as ReactComponent };